function LoginCtrl($http, $mdToast, $mdDialog, $rootScope) {
    "ngInject";

    var main = this;
    $rootScope.loginShown = true;

    main.tryLogin = function() {
        $http.post(
            '/api/v1/admin/login',
            {'email': main.email, 'password': main.password}
        ).then(
            function(response) {
                $mdDialog.hide();
                $rootScope.attemptingLogin = false;
                $rootScope.loginShown = false;
                $rootScope.savePermissions(response.data);
                $rootScope.$broadcast('loggedIn');
            },
            function(response) {
                $rootScope.attemptingLogin = false;
                var message = response.data.message || 'There was an error logging in. Please try again.';
                var alert = $mdToast.simple().textContent(message);
                $mdToast.show(alert);
            }
        );

        $rootScope.attemptingLogin = true;
    };
}

angular.module('app').controller('LoginCtrl', LoginCtrl);
